import { FileText, Upload } from "lucide-react";
import { Card, Badge } from "@/components/ui/primitives";
import type { DocumentDTO } from "@/lib/api";

export function DocumentList({ documents }: { documents: DocumentDTO[] }) {
  return (
    <Card className="p-6">
      <div className="rounded-lg border-2 border-dashed border-border p-8 text-center">
        <Upload className="mx-auto h-6 w-6 text-muted-foreground" strokeWidth={1.6} />
        <div className="mt-3 text-sm font-medium">Drop PDF files here or click to browse</div>
        <div className="mt-1 text-xs text-muted-foreground">Application forms, pay stubs, bank statements, ID, utility bills</div>
      </div>
      <div className="mt-4 text-sm text-muted-foreground">{documents.length} documents ready</div>
      <ul className="mt-3 space-y-1.5">
        {documents.map((d) => (
          <li key={d.id} className="flex items-center gap-3 rounded-md border border-border px-3 py-2">
            <FileText className="h-4 w-4 text-muted-foreground" strokeWidth={1.9} />
            <div className="flex-1 truncate">
              <div className="text-sm">{d.filename}</div>
              <div className="text-xs text-muted-foreground">{d.doc_type_label}</div>
            </div>
            <Badge variant="muted">{d.pages} page{d.pages === 1 ? "" : "s"}</Badge>
          </li>
        ))}
      </ul>
    </Card>
  );
}
